define('OutSystems/ClientRuntime/modules/Database/WebSQL/WebSQLSerializer',["require", "exports", "tslib", "../../../DataTypes", "../../../Logger", "../../../Settings", "../AutoNumber", "../Common/Serializer", "../DatabaseTypeUtils", "../DBDataType"], function (require, exports, tslib_1, DataTypes_1, Logger, Settings_1, AutoNumber_1, Serializer_1, DatabaseTypeUtils_1, DBDataType_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WebSQLSerializer = (function (_super) {
        tslib_1.__extends(WebSQLSerializer, _super);
        function WebSQLSerializer() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.fromMethodCache = new Map();
            _this.attributeReaderImplementation = function (dbRecord, currIndex, name, runtimeType) {
                var typeInfo = {
                    type: DatabaseTypeUtils_1.convertDataTypeToDBDataType(runtimeType),
                };
                return _this.deserialize(dbRecord["o" + currIndex], typeInfo);
            };
            _this.namedAttributeReaderImplementation = function (dbRecord, currIndex, name, runtimeType) {
                var typeInfo = {
                    type: DatabaseTypeUtils_1.convertDataTypeToDBDataType(runtimeType),
                };
                return _this.deserialize(dbRecord[name], typeInfo);
            };
            _this.deserializeAggregate = function (rowOrRowList, dataType, indexRefOrRowReader, attributeOrder) {
                if (_this.isGenericRecordType(dataType)) {
                    var row = rowOrRowList;
                    var recordType = dataType;
                    var indexRef = indexRefOrRowReader;
                    var converter = _this.fromMethodCache.get(recordType);
                    if (!converter) {
                        var attributes = recordType.getAttributes();
                        var converterFunctionCode = _this.generateConverterCode(attributes, dataType);
                        converter = new Function("fromLocalStorage", "GenericRecord", "attributes", "classDef", converterFunctionCode)(_this.deserializeAggregate, DataTypes_1.GenericRecord, attributes, dataType);
                        _this.fromMethodCache.set(recordType, converter);
                    }
                    return converter(row, indexRef, _this.getAttributeReaderImplementation(dataType), attributeOrder);
                }
                else if (_this.isGenericRecordListType(dataType)) {
                    var result = new dataType();
                    var rowList = rowOrRowList;
                    var rowReader = indexRefOrRowReader;
                    var items = [];
                    for (var i = 0; i < rowList.length; i++) {
                        items.push(result.newItem(rowReader(null, rowList.item(i))));
                    }
                    result.pushAll(items);
                    return result;
                }
                else {
                    var type = dataType;
                    throw new Error("Unable to read data from Local Storage. Unknown type " + (type && type.name ? type.name : type));
                }
            };
            return _this;
        }
        WebSQLSerializer.prototype.isGenericRecordType = function (dataType) {
            return !!dataType.isGenericRecordType;
        };
        WebSQLSerializer.prototype.isGenericRecordListType = function (dataType) {
            return !!dataType.isGenericRecordListType;
        };
        WebSQLSerializer.prototype.getAttributeReaderImplementation = function (type) {
            return type.isAnonymousRecord() ? this.namedAttributeReaderImplementation : this.attributeReaderImplementation;
        };
        WebSQLSerializer.prototype.generateAttributesDeclaration = function (attributes) {
            var result = "";
            attributes.forEach(function (attr, index) {
                if (attr.dataType !== DataTypes_1.DataTypes.RecordList) {
                    result += attr.attrName + ": null,\n";
                }
            });
            return result;
        };
        WebSQLSerializer.prototype.generateDeserializerForEachAttribute = function (attributes, dataType) {
            var result = "";
            attributes.forEach(function (attr, index) {
                if (attr.dataType !== DataTypes_1.DataTypes.RecordList) {
                    if (attr.dataType === DataTypes_1.DataTypes.Record && dataType.isAnonymousRecord()) {
                        result += attr.attrName + ": fromLocalStorage(row, attributes[" + index + "].complexType, indexRef),";
                    }
                    else {
                        result += attr.attrName + ": readerImplementation(row, indexRef.value++, attributes[" + index + "].name, attributes[" + index + "].dataType),";
                    }
                }
            });
            return result;
        };
        WebSQLSerializer.prototype.generateConverterCode = function (attributes, dataType) {
            var functionCode = "return function from(row, indexRef, readerImplementation, attributeOrder) {\n            var data = null;\n            if (attributeOrder && attributeOrder.length > 0) {\n                data = {\n                    " + this.generateAttributesDeclaration(attributes) + "\n                };\n                for (var i = 0; i < attributeOrder.length; i++) {\n                    var attrName = attributeOrder[i];\n                    var attr = attributes.filter(function(attr) { return attr.attrName === attrName; })[0];\n                    if (attr.complexType) {\n                        data[attrName] = fromLocalStorage(row, attr.complexType, indexRef);\n                    } else {\n                        data[attrName] = readerImplementation(row, indexRef.value++, attr.name, attr.dataType);\n                    }\n                }\n            } else {\n                data = {\n                    " + this.generateDeserializerForEachAttribute(attributes, dataType) + "\n                };\n            }\n            return new classDef.RecordClass(data);\n        };";
            return functionCode;
        };
        WebSQLSerializer.prototype.serializeDateTime = function (value, typeInfo) {
            if (!Settings_1.getEnvParams().DbNullDatesTZAware && value.eq(DataTypes_1.DateTime.defaultValue)) {
                return Serializer_1.default.NULLDATE_IN_DB;
            }
            var nativeDateTime = value.toNative();
            return (Serializer_1.default.maskFourZeroes(nativeDateTime.getUTCFullYear()) +
                "-" +
                Serializer_1.default.maskTwoZeroes(nativeDateTime.getUTCMonth() + 1) +
                "-" +
                Serializer_1.default.maskTwoZeroes(nativeDateTime.getUTCDate()) +
                " " +
                Serializer_1.default.maskTwoZeroes(nativeDateTime.getUTCHours()) +
                ":" +
                Serializer_1.default.maskTwoZeroes(nativeDateTime.getUTCMinutes()) +
                ":" +
                Serializer_1.default.maskTwoZeroes(nativeDateTime.getUTCSeconds()));
        };
        WebSQLSerializer.prototype.serializeBinaryData = function (value, typeInfo) {
            return value.content === undefined ? null : value.content;
        };
        WebSQLSerializer.prototype.deserializeDateTime = function (value, typeInfo) {
            if (value === Serializer_1.default.NULLDATE_IN_DB && !Settings_1.getEnvParams().DbNullDatesTZAware) {
                return DataTypes_1.DateTime.defaultValue;
            }
            var DateTimeDbParseRegExp = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
            var dtParts = DateTimeDbParseRegExp.exec(value);
            var nativeDateTime = new Date();
            nativeDateTime.setUTCFullYear(parseInt(dtParts[1], 10), parseInt(dtParts[2], 10) - 1, parseInt(dtParts[3], 10));
            nativeDateTime.setUTCHours(parseInt(dtParts[4], 10) || 0, parseInt(dtParts[5], 10) || 0, parseInt(dtParts[6], 10) || 0, 0);
            return new DataTypes_1.DateTime(nativeDateTime);
        };
        WebSQLSerializer.prototype.deserializeBinaryData = function (value, typeInfo) {
            return new DataTypes_1.BinaryData(value);
        };
        WebSQLSerializer.prototype.isConversionNeeded = function (from, to) {
            if (this.isConversionNeededBetweenDBDataTypes(from.type, to.type)) {
                return true;
            }
            if (!!from.isEntityReference !== !!to.isEntityReference) {
                return true;
            }
            if (from.length !== undefined) {
                if (from.decimals !== undefined) {
                    return from.length - from.decimals > to.length - to.decimals;
                }
                return from.length > to.length;
            }
            return false;
        };
        WebSQLSerializer.prototype.isConversionNeededBetweenDBDataTypes = function (from, to) {
            if (from === undefined) {
                return true;
            }
            if (from === to) {
                return false;
            }
            switch (from) {
                case DBDataType_1.default.BOOLEAN:
                    return to !== DBDataType_1.default.INTEGER && to !== DBDataType_1.default.LONGINTEGER;
                case DBDataType_1.default.INTEGER:
                    return to !== DBDataType_1.default.LONGINTEGER && to !== DBDataType_1.default.TEXT;
                case DBDataType_1.default.LONGINTEGER:
                    return to !== DBDataType_1.default.TEXT;
                default:
                    return true;
            }
        };
        WebSQLSerializer.prototype.innerSerializeBasicType = function (value, columnInfo, autoNumber) {
            Logger.trace(this, "WebSQL serializing a value of type " + columnInfo.type);
            if (columnInfo.isPrimaryKey &&
                autoNumber === AutoNumber_1.default.YesIfEmpty &&
                DataTypes_1.equals(value, DatabaseTypeUtils_1.typeDefaultValue(columnInfo.type))) {
                return null;
            }
            if (columnInfo.isEntityReference && DataTypes_1.equals(value, DatabaseTypeUtils_1.typeDefaultValue(columnInfo.type))) {
                return null;
            }
        };
        return WebSQLSerializer;
    }(Serializer_1.default));
    exports.default = WebSQLSerializer;
});
//# sourceMappingURL=WebSQLSerializer.js.map;
